export class BitCrusher {
    constructor(audioCtx) {
        this.ctx = audioCtx;
        this.node = null;
        this.dryWetNode = null;
        this.outputNode = null;
        this.inputNode = null;
    }

    async setup() {
        // Load the AudioWorklet
        try {
            await this.ctx.audioWorklet.addModule(new URL('/worklets/bit-crusher-processor.js', import.meta.url).href);
            this.node = new AudioWorkletNode(this.ctx, 'bit-crusher-processor');
        } catch (e) {
            console.error("Failed to load BitCrusher worklet:", e);
            // Fallback to a pass-through gain if worklet fails
            this.node = this.ctx.createGain();
        }

        this.inputNode = this.ctx.createGain();
        this.outputNode = this.ctx.createGain();
        this.dryGain = this.ctx.createGain();
        this.wetGain = this.ctx.createGain();

        // Default Mix: 50/50
        this.dryGain.gain.value = 0.5;
        this.wetGain.gain.value = 0.5;

        // Routing:
        // Input -> DryGain -> Output
        // Input -> Worklet -> WetGain -> Output
        this.inputNode.connect(this.dryGain);
        this.dryGain.connect(this.outputNode);

        this.inputNode.connect(this.node);
        this.node.connect(this.wetGain);
        this.wetGain.connect(this.outputNode);
    }

    setBits(value) {
        if (this.node && this.node.parameters) {
            const param = this.node.parameters.get('bits');
            param.setTargetAtTime(value, this.ctx.currentTime, 0.01);
        }
    }

    setNormFreq(value) {
        if (this.node && this.node.parameters) {
            const param = this.node.parameters.get('normfreq');
            param.setTargetAtTime(value, this.ctx.currentTime, 0.01);
        }
    }

    setMix(value) {
        // Equal Power Crossfade or Linear
        // Linear for simplicity: 0 = Dry, 1 = Wet
        this.wetGain.gain.setTargetAtTime(value, this.ctx.currentTime, 0.01);
        this.dryGain.gain.setTargetAtTime(1 - value, this.ctx.currentTime, 0.01);
    }

    getInput() {
        return this.inputNode;
    }

    getOutput() {
        return this.outputNode;
    }
}
